module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    staticClass: "transparent py-0",
    attrs: {
      "two-line": ""
    }
  }, [(_vm.item.avatar) ? _c('v-list-tile', {
    attrs: {
      "avatar": "",
      "download": ""
    }
  }, [_c('v-list-tile-avatar', {
    staticClass: "media-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.avatar
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "media-title"
  }, [_c('h5', {
    staticClass: "semibold-blue-title-30"
  }, [_vm._v(_vm._s(_vm.item.title))])]), _vm._v(" "), _c('v-list-tile-sub-title', _vm._l((_vm.item.subtitles), function(subtitle) {
    return _c('span', {
      key: subtitle.key
    }, [_c('span', {
      staticClass: "subtitle-key"
    }, [_vm._v(_vm._s(subtitle.key) + ":")]), _vm._v(" "), _c('span', {
      staticClass: "subtitle-value"
    }, [_vm._v(_vm._s(subtitle.value))])])
  }))], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-500c348e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Media.vue
// module id = 1179
// module chunks = 33 38 45